<lib-not-modal [width]="'min(420px, 92dvw)'" [labelledById]="'cabinet-prompt-dialog-title'">
  <div class="cabinet-prompt-dialog">
    <h3 id="cabinet-prompt-dialog-title" class="cabinet-prompt-dialog__title">
      {{ data.title }}
    </h3>

    @if (data.message) {
      <p class="cabinet-prompt-dialog__message">{{ data.message }}</p>
    }

    <lib-not-input
      class="cabinet-prompt-dialog__input"
      [formControl]="inputControl"
      [label]="''"
      [ariaLabel]="data.title"
      [placeholder]="data.inputPlaceholder ?? ''"
      type="text"
      [maxLength]="300"
    />

    <div class="cabinet-prompt-dialog__actions">
      <lib-cabinet-button
        type="button"
        class="cabinet-prompt-dialog__btn"
        variant="secondary"
        secondaryTone="neutral"
        size="lg"
        [fullWidth]="true"
        [text]="data.cancelLabel ?? 'common.actions.cancel'"
        [action]="{ type: 'action' }"
        (actionEvent)="cancel()"
      />

      <lib-cabinet-button
        type="button"
        class="cabinet-prompt-dialog__btn"
        variant="primary"
        size="lg"
        [fullWidth]="true"
        [text]="data.okLabel ?? 'common.actions.ok'"
        [action]="{ type: 'action' }"
        (actionEvent)="confirm()"
      />
    </div>
  </div>
</lib-not-modal>
